import { Box, TextField, Select } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Create } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import { useState } from "react";
import ReasonType from "@warriortrading/warriortrading.hermes.common.feathers/enums/reasonType";

export const CommonReasonsCreate = () => {
  const {
    saveButtonProps,
    refineCore: { formLoading },
    register,
    formState: { errors },
  } = useForm();
  const [value, setValue] = useState("0");
  const handleChange = (event: SelectChangeEvent) => {
    setValue(event.target.value as string);
  };
  const [sortNo, setSortNo] = useState("");
  return (
    <Create isLoading={formLoading} saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("code", {
            required: "This field is required",
          })}
          error={!!(errors as any)?.code}
          helperText={(errors as any)?.code?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Code"
          name="code"
        />
        <FormControl
          fullWidth
          style={{ marginTop: "10px", marginBottom: "10px" }}
        >
          <InputLabel id="reasonType">ReasonType</InputLabel>
          <Select
            {...register("reasonType", {})}
            labelId="reasonType"
            value={value}
            label="ReasonType"
            onChange={handleChange}
          >
            {Object.values(ReasonType)[1]
              .filter((item: any) => item.value !== ReasonType.MOVE.value)
              .map((item: any) => {
                return (
                  <MenuItem key={item.value} value={item.value}>
                    {item.name}
                  </MenuItem>
                );
              })}
          </Select>
        </FormControl>
        <TextField
          {...register("content", {
            required: "This field is required",
          })}
          error={!!(errors as any)?.content}
          helperText={(errors as any)?.content?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Content"
          name="content"
        />
        <TextField
          {...register("name", {
            required: "This field is required",
          })}
          error={!!(errors as any)?.name}
          helperText={(errors as any)?.name?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Name"
          name="name"
        />
        <TextField
          {...register("sortNo", {
            required: "This field is required",
            validate: () => {
              var intRegex = /^-?\d+$/;
              return intRegex.test(sortNo);
            },
          })}
          error={!!(errors as any)?.sortNo}
          helperText={"SortNo cannot be null and sortNo must be integer!"}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="SortNo"
          name="sortNo"
          value={sortNo}
          onChange={(e) => {
            setSortNo(e.target.value);
          }}
        />
      </Box>
    </Create>
  );
};
